<template>
<b-form @submit="onSubmit" novalidate>
  <h1>{{ $t('privatePage.instructions_header') }}</h1>
    <b-col lg="4" class="col-content">

      <b-form-group id="instructionName">
        <span class="fieldHeader">{{$t('name')}}:</span>
          <b-form-input id="nameInput"
                        type="text"
                        v-model="currentInstruction.name"
                        required
                        :state="stateName">
          </b-form-input>
          <template slot="invalid-feedback">
            {{feedbackName}}
          </template>
      </b-form-group>

      <b-form-group>
        <span class="fieldHeader">{{$t('privatePage.questionFormat_header')}}:</span>
          <b-form-select id="questionFormatForm"
                         :options="questionFormats"
                         value-field="id"
                         text-field="name"
                         v-model="currentInstruction.questionFormatId"
                         required
                         :state="stateQuestionFormat"
                         v-show="currentInstruction.pages.length === 0">
          </b-form-select>
          <span v-show="currentInstruction.pages.length > 0">
            {{currentQuestionFormatValue}}
          </span>
      </b-form-group>

      <b-form-group>
        <b-form-checkbox id="checkbox1"
                     :value="true"
                     :unchecked-value="false"
                     v-model="currentInstruction.isStandardInstruction">
        {{ $t('privatePage.isStandardInstruction') }}
        </b-form-checkbox>
      </b-form-group>

      <b-form-group id="languageFrom" style="margin-top:20px">
        <span class="fieldHeader">{{$t('lang')}}:</span>
        <EasyDataTable
          :headers="tableFields"
          :items="languages"
          :alternating="true"
          :rows-per-page="10000"
          :hide-rows-per-page="true"
        >
          <template #item-countryCode="item">
            <span :class="'me-1 flagItem flag-icon flag-icon-' + item.countryCode"></span>
            <span >{{item.langName}}</span>
          </template>
          <template #item-buttons="item">
            <div v-if="!translationSelected(item.languageId)">
              <b-button @click.stop="onAddTranslation(item.languageId)"
                        size="sm"
                        class="fa fa-plus">
              </b-button>
            </div>
            <div v-else>
              <b-button @click.stop="onDeleteTranslation(item.languageId)"
                        size="sm"
                        class="fa fa-trash"
                        variant="danger">
              </b-button>
            </div>
          </template>
        </EasyDataTable>
      </b-form-group>

      <b-form-group>
        <b-button type="submit" class="me-1">{{ $t('save') }}</b-button>
        <b-button type="button" variant="danger" @click.stop="onDeleteInstruction">{{ $t('delete') }}</b-button>
      </b-form-group>
    </b-col>
  </b-form>
  </template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {},
  name: 'instructions-detail-editor',
  computed: {
    ...mapGetters('testMethodsModule', ['questionFormats']),
    stateName() {
      if (this.currentInstruction && this.currentInstruction.name) {
        return this.currentInstruction.name.length > 0
      }
      return false
    },
    stateQuestionFormat(evt) {
      if (this.currentInstruction.questionFormatId === undefined) return false
      return true
    },
    feedbackName() {
      return this.$t('name_required_feedback')
    },
    tableFields() {
      return [
        { value: 'countryCode', text: '' },
        { value: 'name', text: ' ' },
        { value: 'buttons', text: ' ', tdClass: 'rightAlignedField' }
      ]
    },
    hasTranslations() {
      let noOfLanguages = 0
      let hasTranslations =
        this.currentInstruction &&
        this.currentInstruction.translations &&
        this.currentInstruction.translations.length > 0

      if (!hasTranslations) return false

      this.currentInstruction.translations.forEach(translation => {
        if (translation.languageId) noOfLanguages++
      })
      return noOfLanguages > 0 && hasTranslations
    },
    currentQuestionFormatValue() {
      let format = this.questionFormats.filter(
        q => q.id === this.currentInstruction.questionFormatId
      )

      if (format.length > 0) {
        return format[0].name
      } else {
        return ''
      }
    }
  },
  methods: {
    onSubmit: function(evt) {
      evt.preventDefault()
      this.$emit('onSubmit')
    },
    onDeleteInstruction: function() {
      this.$emit('onDeleteInstruction')
    },
    onAddTranslation: function(languageId) {
      this.$emit('onAddTranslation', languageId)
    },
    onDeleteTranslation: function(languageId) {
      let translation = this.getTranslation(languageId)
      this.$emit('onDeleteTranslation', translation)
    },
    getTranslation(languageId) {
      var translation = null

      if (!this.hasTranslations) {
        return null
      }

      for (let i = 0; i < this.currentInstruction.translations.length; i++) {
        var item = this.currentInstruction.translations[i]
        if (item.languageId === languageId) {
          translation = item
          break
        }
      }

      return translation
    },
    translationSelected(languageId) {
      return this.getTranslation(languageId) !== null
    }
  },
  props: {
    currentInstruction: {},
    languages: {}
  }
}
</script>
